import React from 'react';
import { Button, Icon, Switch, FormGroup, FormControl } from 'components';
import styles from 'styles/campaign_settings_second_step.module.scss';
import ExtraModules from './ExtraModules/index';
import GeoTargeting from './GeoTargeting'
import { AddToUnlock, Bundles, OneCheckUpSell, MultiOneCheckUpSell } from './Types';

const SecondStep = ({
	context,
	setActiveTab,
	stickyHeaderPosition: headerPosition,
	stickyHeader,
	setShowATUAfterText,
	shopContext
}) => {
	const { state: campaign, setItem, validationErrors } = context;
	const is_OCU = campaign.settings.type === 'one_check_up_sell'
	const isOld_OCU = is_OCU && !campaign.settings.multi_one_check_upsell
	return (
		<>
			{campaign.settings.type === 'bundles' && <Bundles {...{ context, shopContext, validationErrors }} />}
			{campaign.settings.type === 'add_to_unlock' && (
				<AddToUnlock {...{ context, validationErrors, setShowATUAfterText }} />
			)}
			{isOld_OCU && <OneCheckUpSell {...{ context, validationErrors }} />}
			{(is_OCU && !isOld_OCU) && <MultiOneCheckUpSell {...{ context, validationErrors }} />}
			<GeoTargeting context={context} />
			<ExtraModules context={context} hasCheckout={false} />
		</>
	);
};

export default SecondStep;
